export default __webpack_public_path__ + "static/media/malaysia4.a5d7e796.jpg";